module.exports = __webpack_public_path__ + "img/session-icon.070d6d11.svg";